<template>
  <BaseCard
    gray
    :style="
      resource?.color ? { 'border-left': `3px solid ${resource.color}` } : {}
    "
    v-test="'employee-availability-card'"
  >
    <Flex direction="column">
      <Flex
        align="center"
        :gap="0.5"
      >
        <BaseCheckbox
          v-model="employee.onMarketplace"
          v-test="'employee-availability-checkbox'"
        />
        <BaseAvatar
          size="l"
          :name="employee.name"
          :color="resource?.color"
          :picture="resource?.picture"
        />
        <span
          :class="$style.name"
          :style="
            resource?.color
              ? { 'background-color': lightColor(resource.color) }
              : {}
          "
        >
          {{ employee.name }}
        </span>
      </Flex>
      <template v-if="employee.onMarketplace">
        <BaseRadio
          v-model="employee.customDays"
          :options="[
            {
              label: $t(
                'admin.treatwell.employee_availability_modal.same_as_roster'
              ),
              value: false
            },
            {
              label: $t(
                'admin.treatwell.employee_availability_modal.custom_days'
              ),
              value: true
            }
          ]"
          v-test="'employee-availability-hours-type'"
        />
        <BaseButtonList
          v-if="employee.customDays"
          v-model="employee.days"
          :options="dayOptions"
          v-test="'employee-availability-days'"
        />
      </template>
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { computed } from 'vue';
import { formatWeekDay } from '@/helpers/dates';
import { lightColor } from '@/helpers/formatting';
import { useResourcesStore } from '@/stores/resources';
import { WEEK } from './days';
import type { EmployeeForm } from './types';

const employee = defineModel<EmployeeForm>({ required: true });

// Same colour treatment as the employee list in the service modal
const { resourceById } = useResourcesStore();
const resource = computed(() =>
  resourceById(Number(employee.value.employeeId)),
);

const dayOptions = WEEK.map((day) => ({
  value: day,
  label: formatWeekDay(day, 'weekdayShort'),
}));
</script>

<style
  lang="scss"
  module
>
.name {
  font-weight: bold;
  padding: 8px;
  border-radius: 8px;
}

</style>
